import PatientScreenDialog from "../../assets/images/patient-screen-dailog.png";
import Checkbox from "../Checkbox/Checkbox";

const SubscriptionDialog = ({
  handleDialog,
  description,
  handleLearnMore,
  setShowPreview,
}: {
  handleDialog: (val: boolean) => void;
  description: string;
  handleLearnMore?: () => void;
  setShowPreview: any;
}) => {
  return (
    <div className="relative 12">
      <img src={PatientScreenDialog} alt="" className="hidden md:block" />
      <div className="relative md:absolute md:top-10 md:left-12 z-10 w-full md:w-7/12 bg-[#DDEE59] md:bg-transparent p-6 md:p-0 rounded-lg md:rounded-none">
        <h3 className="heading font-normal text-2xl uppercase">New Annual Plan Available</h3>
        <p>Your doctor has a annual plan available that will save you money on your form requests.</p>
        <div dangerouslySetInnerHTML={{ __html: description }} className="h-28 overflow-hidden py-4" />
        <p className="text-xs text-docsigna-orange cursor-pointer mt-1" onClick={handleLearnMore}>
          Learn More
        </p>
        <h3 className="heading font-normal text-lg mt-2">Interested in joining?</h3>
        <div className="flex gap-3 mt-3">
          <button onClick={() => setShowPreview(false)} className="bg-slate-500 rounded-full px-7 py-1 text-white">
            No thanks
          </button>
          <button onClick={() => handleDialog(true)} className="bg-docsigna-orange rounded-full px-7 py-1 text-white">
            Sign Me Up
          </button>
        </div>
        <div className="mt-5">
          <Checkbox label="Don’t show me again" onChange={() => handleDialog(false)} />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionDialog;
